import { Editor, NodeEntry, Transforms } from 'slate'
import { Equation, Math } from './interfaces'

export function normalize(editor: Editor, entry: NodeEntry): boolean {
  const [node, path] = entry

  if (Math.isMath(node) && node.placement === 'block') {
    const [parent] = Editor.parent(editor, path)

    if (!Equation.isEquation(parent)) {
      Transforms.wrapNodes(
        editor,
        { type: 'equation', children: [] },
        { at: path },
      )
      return true
    }
  }

  if (Equation.isEquation(node)
  && Math.isMath(node.children[0]) && node.children[0].placement !== 'block') {
    Transforms.setNodes(editor, { placement: 'block' }, { at: [...path, 0] })
  }

  return false
}
